<template>
    <Head title="Forgot Password" />

    <div class="w-100 h-[calc(100vh-64px)] bg-gray-100">
        <div class="m-auto max-w-md pt-24">
            <div class="rounded border border-gray-100 bg-white p-8 shadow">
                <div
                    class="mb-6 text-[28px] font-semibold leading-none tracking-tight"
                >
                    Forgot Password?
                </div>

                <form @submit.prevent="submit">
                    <div class="my-4 text-[16px] leading-7 text-gray-700">
                        Enter your email address and we’ll send you a reset link
                        that allows you to choose a new password
                    </div>

                    <div>
                        <form-input
                            label="Email address"
                            id="email"
                            type="email"
                            name="email"
                            label-classes="block text-base"
                            css-classes="rounded border-gray-50 bg-gray-50 focus:border-primary-300 focus:border w-full shadow  pr-8"
                            v-model="form.email"
                            :autofocus="true"
                        />
                    </div>

                    <div class="mt-8 flex flex-col items-center">
                        <button
                            :class="
                                'btn btn-primary w-full text-center' +
                                ' ' +
                                { 'opacity-25': form.processing }
                            "
                            :disabled="!form.email || form.processing"
                            @button-click="submit()"
                        >
                            Send password reset email
                        </button>
                        <Link
                            :href="route('login')"
                            class="btn btn-transparent mt-4 text-gray-700"
                        >
                            Back to Login
                        </Link>
                    </div>
                </form>
            </div>

            <div
                v-if="status && status === 'passwords.sent'"
                class="mt-4 rounded bg-green-100 p-4 text-[24px] leading-snug text-green-400"
            >
                <span class="block font-semibold capitalize">Success!</span>
                <span>
                    We have sent you a reset link. Please check your email to
                    reset your password
                </span>
            </div>

            <div class="my-8 w-full text-center text-gray-700">
                Still having issues?
                <Link class="link" :href="route('frontend.contact-us')">
                    Contact Us
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import FrontendFullscreen from "@/_Layouts/FrontendFullscreen";
import Button from "@/Components/Button.vue";
import FormErrors from "@/Components/FormErrors.vue";
import FormInput from "@/Components/FormInput";

export default {
    name: "ForgotPassword",
    layout: FrontendFullscreen,
    components: {
        FormInput,
        Button,
        FormErrors,
    },
    props: {
        status: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                email: "",
            }),
        };
    },
    methods: {
        submit() {
            let vm = this;

            vm.$inertia.post(
                route("password.email"),
                {
                    email: vm.form.email,
                },
                {
                    replace: true,
                    preserveState: false,
                }
            );
        },
    },
};
</script>

<style scoped></style>
